import { render, staticRenderFns } from "./BudgetPerCategory.vue?vue&type=template&id=652812ba&"
import script from "./BudgetPerCategory.vue?vue&type=script&lang=js&"
export * from "./BudgetPerCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports